export default __webpack_public_path__ + "static/media/foot-left-back.c2ffbd7b.png";